<template lang="pug">
div
  .input(v-if="data.type === 'input'")
    v-text-field(
      v-for="(answer, j) in data.values",
      :key="j",
      outlined,
      :label="answer.label",
      v-model="inp",
      @change='changeAnswer'
      :disabled="isInputDisabled(data, answer)"
    )

  .input(v-if="data.type === 'date'")
    v-menu(
      v-for="(answer, j) in data.values",
      :key="j",
      ref="menu",
      min-width="290px",
      offset-y,
      transition="scale-transition",
      :close-on-content-click="false",
      v-model="menu",
      :disabled="isInputDisabled(data, answer)"
    )
      template(v-slot:activator="{ on, attrs }")
        v-text-field(
          :label="answer.label",
          prepend-icon="mdi-calendar-month",
          readonly,
          v-on="on",
          v-bind="attrs",
          v-model="inp",

          :disabled="isInputDisabled(data, answer)"
        )
      v-date-picker(no-title, scrollable, v-model="inp" @change='changeAnswer')
        v-spacer
        v-btn(text, color="primary", @click="menu = false") cancel
        v-btn(text, color="primary", @click="menu = false") ok

  .autocomplete(v-if="data.type === 'autocomplete'")
    v-autocomplete(
      v-for="(answer, j) in data.values",
      :key="j",
      hide-details,
      hide-no-data,
      hide-selected,
      item-text="title",
      item-value="value",
      outlined,
      :label="answer.label",
      placeholder="Start typing to Search",
      return-object,
      :loading="isLoading",
      :search-input.sync="search",
      :items="autocompleteItems",
      @input="changeAnswer",
      :disabled="isInputDisabled(data, value)"
    )

  EditJobTitle(":value"="data.alias_result" @input='changeAnswer' v-if="data.type === 'job-titles'")
  .selects(v-if="data.type === 'select'")
    v-select(
      v-for="(answer, j) in data.values",
      :key="j",
      outlined,
      @change='changeAnswer'
      :label="answer.label",
      :items="getSelectItems(answer)",
      v-model="inp",
      :disabled="isInputDisabled(data, answer)"
    )

  v-radio-group(v-if="data.type == 'radio'", v-model="inp"  @change='changeAnswer')
    .radio.mb-4(v-for="(value, k) in data.values", :key="k")
      v-radio(:value="value.value", :disabled="isInputDisabled(data, value)")
        template(v-slot:label)
          span(v-html="value.label")
          v-tooltip(v-if="value.info", bottom, max-width="300")
            template(v-slot:activator="{ on }")
              v-icon.ml-2(v-on="on") mdi-information-outline
            span(v-html="value.info")

  div(v-if="data.type == 'checkbox'", v-model="inp")
    .radio.mb-4(v-for="(value, j) in data.values", :key="j")
      v-checkbox(
        hide-details,
        :value="value.value",
        @change='changeAnswer'
        :disabled="isInputDisabled(data, value)"
      )
        template(v-slot:label)
          span(v-html="value.label")
          v-tooltip(v-if="value.info", bottom, max-width="300")
            template(v-slot:activator="{ on }")
              v-icon.ml-2(v-on="on") mdi-information-outline
            span(v-html="value.info")
</template>

<script>
import EditJobTitle from './EditAnswerBlocks/JobTitles/index'
export default {
  components: { EditJobTitle },
  name: "answer-block--editor",

  props: ["data", 'questionID', 'stepID', 'userflowID'],

  data() {
    return {
      inp: this.data.alias_result,
      menu: false,
    };
  },
  methods: {
    changeAnswer(val) {
      this.axios.post(`/flow/userflow/${this.userflowID}/step/${this.stepID}/question/${this.questionID}/answer/${this.data.ID}`, {
        answer: val,
        alias: this.data.alias
      }).then(() => {
        this.$emit('refresh')
      })
    },
    isInputDisabled() {
      return this.data.skip_step;
    },
    getSelectItems(answer) {
      if (answer.loop_answer_items_alias) return answer.loop_select_items;
      return answer.answer_select_items.values.split(",,");
    },
  },
};
</script>